export const srConsoleInputsData = [
    {
        key: 'destination',
        title: 'Charter from?',
        placeholder: 'Destination',
        tooltip: 'Enter a destination or port',
        clickHandler: () => { },
        optionsKey: 'destinationOptions',
        displayType: 'checkbox-group'
    },
    {
        key: 'dates',
        title: 'When?',
        placeholder: 'Choose your dates',
        tooltip: 'Select your travel dates',
        clickHandler: () => { },
        optionsKey: 'months',
        displayType: 'list'
        // setActiveFieldIndex(1);
        // setModalData({
        // title: 'When',
        // type: 'list',
        // content: generateLuxonMonthOptions()
        // });

    },
    {
        key: 'guests',
        title: 'Who?',
        placeholder: 'Enter number of guests',
        tooltip: 'Specify the number of guests',
        displayType: 'list',
        clickHandler: () => {
            // setActiveFieldIndex(2);
            // setModalData({
            //     title: 'Who',
            //     type: 'list',
            //     content: guestOptions
            // });
        },
        optionsKey: 'guestOptions'
    },
    {
        key: 'yacht',
        title: 'Yacht type?',
        placeholder: 'Motor, Sailing',
        tooltip: 'Select your Yaght type',
        displayType: 'list',
        clickHandler: () => {
            // setActiveFieldIndex(3);
            // setModalData({
            //     title: 'Yacht type',
            //     type: 'list',
            //     content: yachtTypeOptions
            // });
        },
        optionsKey: 'yachtTypeOptions'
    }
];